import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { ATTRIBUTES_QUERY_KEY, QUERY_CACHE_LONG_EXPIRATION_MS } from "@config/query";
import { IAttribute } from "@interfaces/attribute.interface";
import attributeService from "@services/attribute.service";

import { filterAttributesForCompany } from "../utils";

export function useAllAttributes() {
  return useQuery({
    queryKey: [ATTRIBUTES_QUERY_KEY],
    queryFn: () => attributeService.getAttributes(),
    staleTime: QUERY_CACHE_LONG_EXPIRATION_MS,
    placeholderData: keepPreviousData,
  });
}

/** Attributes applicable to a company, optionally narrowed to a company type. */
export function useCompanyAttributes({ type }: { type?: string } = {}) {
  const { data: attributes, ...rest } = useAllAttributes();

  const data = useMemo<IAttribute[]>(
    () => (attributes ? filterAttributesForCompany(attributes, type) : []),
    [attributes, type]
  );

  return { data, ...rest };
}
